<template>
    <div class="work_index">
       <div class="work_index_top">
            应用管理
       </div>

       <div class="work_index_item" v-for="(app,index) in  WorkIndexList" :key="index" >
            <p>{{app.WorkIndexListName}}</p>
            <ul>
               <li v-for="(item,index) in app.WorkIndexListItem" :key="index"  >
          
                  <router-link class="work_option"  :to="item.goto" v-if="item.isChild" >
                    <img :src=item.currentSrc>
                    <div>{{item.name}}</div>
                  </router-link> 

                  <a v-else :href="item.goto"  style="cursor: pointer"  class="work_option" >
                     <img :src=item.currentSrc>
                    <div>{{item.name}}</div>
                  </a>
              
            </li>

              
            </ul>
      </div>   


     <!-- <WorkIndexItem v-for="(item,index) in  WorkIndexList" :applist="item.WorkIndexListItem" :applistname="item.WorkIndexListName" :key="index"></WorkIndexItem>-->
    </div>
</template>

<script>
import WorkIndexItem from './work-index-item.vue'
  export default{
      components:{
         WorkIndexItem
      },
      data(){
            return{
               WorkIndexList:[
                  //审批应用
                  {
                     WorkIndexListName:"审批应用",
                     WorkIndexListItem:[
                     {
                        name:'请假',
                        currentSrc : require("@/assets/work/qingjia.png"),
                        goto:'/personal-work-approval-leave',
                        isChild:1
               
                     },
                     {
                        name:'出差加班',
                        currentSrc : require("@/assets/work/chuchai.png"),
                        goto:'/personal-work-approval-travel',
                        isChild:1
                 
                     },
                     {
                        name:'报销',
                        currentSrc : require("@/assets/work/baoxiao.png"),
                        goto:'/personal-work-approval-reimbursement',
                        isChild:1
                     },
                     {
                        name:'收款',
                        currentSrc : require("@/assets/work/shoufei.png"),
                        goto:'/personal-work-approval-collection',
                        isChild:1
                     
                     },
                    /* {
                        name:'申请提拔',
                        currentSrc : require("@/assets/work/tiba.png"),
                        goto:' /personal-work-approval-promotion'
                     },*/
                    ],
                  },
                  //战报应用
                  {
                     WorkIndexListName:"战报应用",
                     WorkIndexListItem:[
                     {
                        name:'日报提交',
                        currentSrc : require("@/assets/work/ribao.png"),
                        goto:'/personal-work-report-day',
                        isChild:1
                
                     },
                     {
                        name:'周报提交',
                        currentSrc : require("@/assets/work/zhoubao.png"),
                        goto:'/personal-work-report-week',
                        isChild:1
            
                     },
                     {
                        name:'月报提交',
                        currentSrc : require("@/assets/work/yuebao.png"),
                        goto:'/personal-work-report-month',
                        isChild:1
      
                     },
                     {
                        name:'战报记录',
                        currentSrc : require("@/assets/work/zhanbao.png"),
                        goto:'/personal-work-report-record-index',
                        isChild:1
                     },
                    ],
                  },
                   //其他应用
                  {
                     WorkIndexListName:"其他应用",
                     WorkIndexListItem:[
                       {
                        name:'职位列表', 
                        currentSrc : require("@/assets/work/zhiwei.png"),
                        goto:'/personal-enroll-job',
                        isChild:1
                       },

                       {
                        name:'组团', 
                        currentSrc : require("@/assets/work/zhiwei.png"),
                        goto:'/personal-work-other-job',
                        isChild:1
                       },

                       {
                        name:'推广', 
                        currentSrc : require("@/assets/work/zhiwei.png"),
                        goto:'/personal-work-other-job',
                        isChild:1
                       },

                       {
                        name:'共享', 
                        currentSrc : require("@/assets/work/zhiwei.png"),
                        goto:'/personal-work-other-job',
                        isChild:1
                       },


                      
                       
                    ],
                  }
               ],
            };
      },
      methods:{
         goTo (name) {
            let routeData = this.$router.resolve({ name: name, });
            window.open(routeData.href, '_blank');

         },
      }
  }

</script>

<style>
 .work_index{
      width: 1200px;
      margin: 0 auto;
 }
  .work_index_top{
      width: 100%;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: bolder;
      border-bottom: 1px solid #CCCCCC;
 }

 .work_index_item{
      margin-top: 38px;
 }
 .work_index_item ul{
      margin-top: 23px;
      display: flex;
 }
 .work_index_item ul .work_option{
      width: 180px;
      height: 60px;
      margin-right: 19px;
      border: 1px solid #CCCCCC;
      border-radius: 10px;
      display: flex;
 }
 .work_index_item ul .work_option img{
      height: 39px;
      width: 39px;
      margin-top: 11px;
      margin-left: 13px;
 }
 .work_index_item ul .work_option div{
      margin-left: 20px;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;
      user-select:none;
      color: #181818;
 }
</style>